<script>
    import PopupInfo from '@/components/popups/PopupInfo.vue';

    export default {
        components: {
            PopupInfo: PopupInfo,
        },
        computed: {
            popups() { return this.$store.getters.POPUPS },
        }
    }
</script>


<template>
    <div class="popup_info_container">
        <PopupInfo 
            v-for="(popupValue, popupIndex) in popups" :key="popupIndex"
            :popup = "popupValue"
        />
    </div>
</template>